module.exports = __webpack_public_path__ + "static/img/jdxyyyq_1.88f6eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/jdxyyyq_1.jpg
// module id = 8+NY
// module chunks = 15